<!--
상품 추가
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xlarge">

            <div class="uk-modal-header">
                <h4>검수요청사항 수정</h4>
            </div>
            <div class="uk-modal-body uk-padding-small">
                <app-input-ex
                    class="uk-margin-small-bottom"
                    type="textarea"
                    input-size="small"
                    :textarea-rows="3"

                    name="request"
                    v-model="inputs.request"
                    label="검수요청사항"

                    :validate-rules="{required: true}"
                    required
                    required-layout="label-left"

                    placeholder="작업자에게 전달할 내용을 구체적으로 작성하세요"
                > </app-input-ex>

            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // 입력값 object
                inputs: {
                    request: null,
                },

                // 검수요청ID
                checkRequestId: null,
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param check_request_id 검수요청ID
             */
            form(check_request_id) {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/check-requests/' + check_request_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    let check_request = response.check_request;

                    // id 저장
                    this.checkRequestId = check_request.id;

                    // 팝업 설정
                    _.assignIn(this.inputs, {
                        request: check_request.request,
                    });


                    // 폼띄우기
                    this.displayForm();
                });
            },

            /**
             * submit
             */
            submit() {
                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/check-requests/' + this.checkRequestId,
                    data: _.merge({
                        '_token': this.csrfToken,
                    }, this.inputs),
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>